import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { IIncidenceResolution } from 'modules/sales/incidence-resolution/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { IncidenceResolutionCell } from '../components/IncidenceResolutionCell';
import { IncidenceResolutionStatus } from '../components/IncidenceResolutionStatus';
import { createdByColumn } from 'modules/sales/incidence/constants';
import { ORDER_REFERENCE_TYPE } from 'modules/sales/common/constants/order.enum';
import { INCIDENCE_RESOLUTION_PERMISSIONS } from './incidence-resolution.permissions';
import PriceCell from 'modules/security/audit-logs/components/TableCells/PriceCell';
import { TranslateLabel } from 'modules/common/components/TranslateLabel';

export const incidenceResolutionTypeColumn: HeadCell<IIncidenceResolution> = {
  field: 'type',
  headerName: 'incidenceResolution:fields.type',
  disablePadding: false,
  component: IncidenceResolutionCell,
};

export const solutionTypeColumn: HeadCell<IIncidenceResolution> = {
  field: 'actionType',
  headerName: 'incidenceResolution:fields.type',
  disablePadding: false,
  width: 250,
  component: IncidenceResolutionCell,
};

export const incidenceResolutionOrderColumn: HeadCell<IIncidenceResolution> = {
  field: 'orderReference',
  headerName: 'incidence:type.ORDER',
  renderCell: (value: string, data?: any) => (
    <AvatarNameCell
      name={data?.orderReference?.code}
      link={`/sales/${data?.referenceType === ORDER_REFERENCE_TYPE.SUB_ORDER ? 'sub-orders' : 'orders'}/${data?.orderReference?._id as string}/general`}
      hideImage
    />
  ),
};

export const incidenceResolutionCodeColumn: HeadCell<IIncidenceResolution> = {
  field: 'code',
  headerName: 'common:code',
  renderCell: (value: string, data?: any) => (
    <AvatarNameCell
      name={value}
      link={`/sales/incidence-resolutions/${data?._id as string}`}
      hideImage
    />
  ),
};

export const actionTypeColumn: HeadCell<IIncidenceResolution> = {
  field: 'actionType',
  headerName: 'incidenceResolution:fields.type',
  disablePadding: false,
  renderCell: (value: string) => <TranslateLabel label={`actions.${value}`} locale='incidence' />,
};

export const incidenceResolutionIncidenceColumn: HeadCell<IIncidenceResolution> = {
  field: 'incidentReference',
  headerName: 'incidenceResolution:fields.incidence',
  renderCell: (value: string, data?: any) => (
    <AvatarNameCell
      name={data?.incidentReference?.code}
      link={`/sales/incidences/${data?.incidentReference?._id as string}/general`}
      hideImage
    />
  ),
};

export const incidenceResolutionRefundColumn: HeadCell<IIncidenceResolution> = {
  field: 'refund.total',
  headerName: 'incidenceResolution:fields.refund',
  renderCell: (value: number) => <PriceCell value={value} />
};

export const incidenceResolutionBillsColumn: HeadCell<IIncidenceResolution> = {
  field: 'chargeToResponsible.total',
  headerName: 'incidenceResolution:fields.bills',
  renderCell: (value: number) => <PriceCell value={value} />
};

export const incidenceResolutionChargeToClientColumn: HeadCell<IIncidenceResolution> = {
  field: 'chargeToClient.total',
  headerName: 'incidence:summary.chargeToClient',
  align: CellAlign.CENTER,
  renderCell: (value: number) => <PriceCell value={value} />
};

export const incidenceResolutionStatusColumn: HeadCell<IIncidenceResolution> = {
  field: 'refund.status',
  headerName: 'common:status',
  permissions: [INCIDENCE_RESOLUTION_PERMISSIONS.INCIDENCE_RESOLUTION_WRITE],
  renderCell: (value: string, data?: IIncidenceResolution) => <IncidenceResolutionStatus data={data as IIncidenceResolution} />,
};

export const resolutionCodeColumn: HeadCell<IIncidenceResolution> = {
  field: 'resolutionInfo.code',
  headerName: 'common:code',
  renderCell: (value: string, data?: any) => (
    <AvatarNameCell
      name={value}
      link={`/sales/incidence-resolutions/${data?.resolutionInfo?._id as string}`}
      hideImage
    />
  ),
};
export const incidenceResolutionColumns: Array<HeadCell<any>> = [
  incidenceResolutionCodeColumn,
  incidenceResolutionTypeColumn,
  incidenceResolutionOrderColumn,
  incidenceResolutionIncidenceColumn,
  incidenceResolutionChargeToClientColumn,
  incidenceResolutionRefundColumn,
  incidenceResolutionBillsColumn,
  incidenceResolutionStatusColumn,
  createdByColumn,
  createdATColumn,
];
